import React, { Component } from "react";
import "./InsertPhone.css";
import Button from "../components/Button";
import Title from "../components/Title";
import CodeInput from '../components/CodeInput';
import Countdown from "react-countdown-now";

class InserCode extends Component {

  constructor(props) {
    super(props);
    this.initialState = {
      firstFill:false,
    }
    this.state = this.initialState;
  }

  handleClick = () => {
    this.props.sendCodeHandler();
  };

  onChangeHandler = (inputNum) => {
    const code = this.code1.value()+''+this.code2.value()+''+ this.code3.value()+''+this.code4.value()
    if(!this.state.firstFill && code.length >= 4) {
      const newState= {firstFill: true};
      this.setState( ()=>newState ) 
    }
    this.props.onChange(code)
    this.processFocus(inputNum)
  };
  
  processFocus = (inputNum) => {
    const input = this['code'+inputNum]
    if(input.value().length>=1) {
      if(inputNum>=1 && inputNum<4) {
        const nextInput = this['code'+(inputNum+1)].input.inputElement//.inputElement
        nextInput.focus()
      } else {
        this.button.buttonElement.focus()
      }
    }
  }

  onBlurHandler = e => {
    if(this.state.firstBlur) {
      let newState = {}
      newState.firstBlur = false;
      this.setState( () => newState);
    }
  };

  render() {
    const { firstFill } = this.state
    const { phone, value, valid, errorMessage } = this.props;
    const [c1='', c2='', c3='', c4=''] = value.split('')
    //const skipCode = true;

    const Completionist = () => { 
      this.props.onResendClick()
      return <span>Reenviando SMS</span>
    }

    // Renderer callback with condition
    const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
        // Render a complete state
        return <Completionist />;
      } else {
        // Render a countdown
        return <span> {("00" + minutes).slice(-2)}:{("00" + seconds).slice(-2)}</span>;
      }
    };
    //if (skipCode==false)
    return (
      <React.Fragment>
        <Title text="Insira seu código" />
        <div className="ha-bx">
          Insira o código enviado por SMS para <br/>
          {phone}
          {/* 
          <div>
            <LinkButton label="REENVIAR" onClick={this.props.onResendClick}/>
          </div>
          */}
          <div>
          <br/>
          Reenvio do SMS em: 
          <Countdown date={new Date(Date.now() + 300000)} renderer={renderer}/>
          </div>
        </div>
        <div className='ha-vv' >
          <CodeInput ref={input => { this.code1 = input; }} autoFocus={true} onChange={this.onChangeHandler} value={c1} index={1}/>
          <CodeInput ref={input => { this.code2 = input; }} onChange={this.onChangeHandler} value={c2} index={2}/>
          <CodeInput ref={input => { this.code3 = input; }} onChange={this.onChangeHandler} value={c3} index={3}/>
          <CodeInput ref={input => { this.code4 = input; }} onChange={this.onChangeHandler} value={c4} index={4}/>
        </div>
        { (firstFill && !valid ) && (<div>{errorMessage}</div>)} 
        <Button ref={input => { this.button = input; }} label="continuar" onClick={this.handleClick} disabled={!valid}/>
      </React.Fragment>
    );
    // else{
    //   //chamar metodo de autenticacao com o codigo recebido da api
    //   //trazer code da api
    //   this.props.onChange(code);
    //   this.props.sendCodeHandler()
    //   return (<Text>Confirmando</Text>);
    // }
          
  }
}

export default InserCode;
